export const integerAndFloatRegex = /^(\d+(?:\.\d+)?)$/;

export const bankingRoutingRegex = /^\d{8,9}$/;
